var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartdocumentIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.4875649,20.0744523 L29.4306779,17.2929455 C30.510592,17.0608693 31.5741703,17.7481777 31.8062465,18.8280918 C31.8639757,19.0967217 31.8657347,19.3743654 31.8114137,19.6437051 L29.0559821,33.3059736 C28.896823,34.095133 28.280019,34.7119369 27.4908597,34.8710961 L13.9322812,37.6056153 C12.8495133,37.8239899 11.7947289,37.1232608 11.5763543,36.0404929 C11.5178983,35.7506502 11.5244352,35.4514519 11.5954944,35.164439 L14.9663914,21.549158 C15.1500538,20.8073333 15.7404009,20.2350196 16.4875649,20.0744523 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-471.000000, -6217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(471.000000, 6217.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#47B7FF",
    transform: "translate(21.625692, 27.440805) rotate(-315.000000) translate(-21.625692, -27.440805) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1464846,12.6473391 L30.1808214,9.40915241 C31.2571127,9.16081633 32.3309353,9.83200665 32.5792714,10.908298 C32.6481975,11.2070245 32.6475261,11.5175982 32.5773091,11.816024 L29.1932537,26.1984205 C29.0160081,26.9517229 28.4200862,27.5351682 27.6632026,27.6964374 L13.7579691,30.659226 C12.67765,30.8894097 11.6152777,30.2002387 11.385094,29.1199197 C11.3241826,28.8340444 11.326672,28.5382925 11.3923869,28.2534831 L14.6473391,14.1464846 C14.819295,13.401226 15.401226,12.819295 16.1464846,12.6473391 Z",
    id: "\\u77E9\\u5F62",
    fill: "#2A7DFF",
    transform: "translate(22.000000, 20.000000) rotate(-315.000000) translate(-22.000000, -20.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartdocumentIconBig);
export default __webpack_public_path__ + "static/media/Smartdocument_icon_big.b822a28d42c4fd369ff5759088c1d502.svg";
export { ForwardRef as ReactComponent };